export const page2 = {
  "name": "page2",
  "elements": [
    {
      "type": "radiogroup",
      "name": "gender",
      "title": "What is Your biological gender?",
      "isRequired": true,
      "choices": [
        {
          "value": "Item 1",
          "text": "Female"
        },
        {
          "value": "Item 2",
          "text": "Male"
        },
        {
          "value": "Item 3",
          "text": "Other"
        }
      ]
    },
    {
      "type": "text",
      "name": "chronologicalAge",
      "isRequired": true,
      "title": "What is Your chronological age?",
      "inputType": "number",
      "min": 6,
      "max": 120
    }
  ]
};